import { useQuery } from 'react-query';
import { type SessionPagesResponse } from '../dtos/SessionPagesDto';
import { logger, fetcher } from '../utils/Fetcher';
import { API_URLS } from '../utils/urls';

const useSessionSpeakerPages = () => {
  return useQuery('SessionSpeakerPages', async () => {
    try {
      const response = await fetcher.get<SessionPagesResponse>(API_URLS.SESSION_LIST);

      return response;
    } catch (error) {
      logger.error(error);
      throw error;
    }
  });
};

export default useSessionSpeakerPages;
